import type { ModelGrid } from '@cadstrom/sigma-engine-shared';

/** Fraction of the final viewport width/height used as padding on each side when zooming to a selection. */
export const ZOOM_PADDING_FRACTION = 0.3;

/** Grid assumed for a design that does not specify its own. */
export const DEFAULT_MODEL_GRID: ModelGrid = { distance: 0.1, units: 'mm' };
